import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    deleteBtsHistoryRequest: ['response'],
    deleteBtsHistorySuccess: ['response'],
    deleteBtsHistoryFailure: ['error'],
})

export const deleteBtsHistoryTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    response: null,
    error: null,
    loading: null,
})

/* ------------- Reducers ------------- */

const deleteBtsHistoryRequest = state => state.merge({ success: null })

const deleteBtsHistorySuccess = (state, { response }) =>
    state.merge({
        success: true,
        error: false,
        response,
    })

const deleteBtsHistoryFailure = (state, { error }) => {
    const { response } = error
    return state.merge({
        success: false,
        error: true,
        response,
    })
}
export const reducer = createReducer(INITIAL_STATE, {
    [Types.DELETE_BTS_HISTORY_REQUEST]: deleteBtsHistoryRequest,
    [Types.DELETE_BTS_HISTORY_SUCCESS]: deleteBtsHistorySuccess,
    [Types.DELETE_BTS_HISTORY_FAILURE]: deleteBtsHistoryFailure,
})
